import { RootState } from '../reducers';
import { LoadersNames } from './ui.actions';

export const getLoader = (loaderName: LoadersNames) => (state: RootState): boolean | [] =>
  state.ui.loaders[loaderName] || false;
